<template>
  <div class="sm-manage-live-answering">
    <h5>Live Answering recipients</h5>
    <ul class="sm-manage-live-answering__list">
      <li
        v-for="user in list"
        :key="user.id"
      >
        <div class="sm-manage-live-answering__list-item">
          <text-truncate
            :text="`${user.first_name} ${user.last_name}`"
          />
          <a
            href="#"
            @click.prevent="openPopup('edit', user)"
          >Edit</a>
          <a
            href="#"
            class="sm-error"
            @click.prevent="openPopup('delete', user)"
          >Delete</a>
        </div>
      </li>
    </ul>

    <popup-block
      v-if="popup.isOpen"
      :open="popup.isOpen"
      @close="popup.isOpen = false;"
    >
      <template slot="popupContent">
        <form-edit-additional
          v-if="popup.type == 'edit'"
          :startVal="popup.item"
          @reset="popup.isOpen = false"
          @submit="handleEdit"
        />
        <confirm-block
          v-if="popup.type == 'delete'"
          :text="`${popup.item.first_name} ${popup.item.last_name} will be deleted.`"
          :confirmType="'error'"
          @cancel="popup.isOpen = false"
          @confirm="confirmDelete"
        />
      </template>
    </popup-block>
  </div>
</template>

<script>
import FormEditAdditional from '@/components/forms/FormEditAdditional';
import Confirm from '@/components/Confirm';
import Popup from '@/components/Popup';

export default {
  name: 'manage-live-answering',
  components: { 
    'form-edit-additional': FormEditAdditional,
    'confirm-block': Confirm,
    'popup-block': Popup
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      popup: {
        isOpen: false,
        type: '', // values: edit, delete
        item: null
      }
    }
  },
  methods: {
    openPopup(type, item) {
      this.popup = {
        isOpen: true,
        type,
        item
      }
    },
    handleEdit(data) {
      this.popup.isOpen = false;
      this.$emit('update', data);
    },
    confirmDelete(id) {
      this.popup.isOpen = false;
      this.$emit('delete', this.popup.item.id);
    }
  }
}
</script>

<style lang="scss">
@use '@/assets/scss/general/mixins.scss' as *;
@use '@/assets/scss/framework/scss-variables.scss' as *;
@use '@/assets/scss/components/account/_manage-live-answering.scss';
</style>
